import React from "react";
import dayjs from "dayjs";

interface IProps {
  value: string;
  format: string;
}

/**
 * A tear-off calendar leaf. Its width follows the viewport within fixed bounds rather than the text
 * beside it, so a long service name can no longer squeeze it, and the type scales off its own width
 * (`cqw`) to keep the leaf's proportions at every size.
 */
export default function DayCalendarUI(props: IProps) {
  const { value, format } = props;

  return (
    <div className="flex-none w-[clamp(88px,8vw,120px)] aspect-[20/21] flex flex-col rounded-lg border border-[#E1E4E5] overflow-hidden [container-type:inline-size]">
      <div className="bg-common-blue300 text-center whitespace-nowrap text-[length:clamp(11px,12cqw,14px)] text-common-white font-semibold font-['Inter'] py-[5px]">
        {dayjs(value, format).format("MM/YYYY")}
      </div>

      <div className="grow flex justify-center items-center text-[length:30cqw] leading-none font-semibold font-['Inter']">
        {dayjs(value, format).format("DD")}
      </div>
    </div>
  );
}
